import { Component, OnInit } from '@angular/core';
import { NotifierService } from 'angular-notifier';
import { DataService } from '../../../services/data.service';
import { Paginado} from '../../../models/paginado';
import { TablaReportes } from '../../../interfaces/interfaces';
import { AuthService } from '../../../services/auth.service';


@Component({
  selector: 'app-reportes',
  templateUrl: './reportes.component.html',
  styleUrls: ['./reportes.component.css']
})
export class ReportesComponent implements OnInit {
  fechaFin:any;
  fechaInicio:any;
  loadingGeneral: boolean = true;
  paginadoReportes: Paginado= new Paginado();;
  tablaIniciativas: TablaReportes[] = [];
  totalRegistros:number;
  emailUser:string;
  idRolSeleccionado:number;
  nombreArchivoSolicitud:string;
  contentFile:string="reporte_iniciativas";



  constructor(private dataService: DataService,  
              private notifier: NotifierService,
              private authService: AuthService) 
  { }

  ngOnInit(): void {
    this.authService.escuchaRolSeleccionado().subscribe((res) => {
      this.idRolSeleccionado = res; });
    this.authService.user.subscribe((user: string) => {
      {this.emailUser = user}
      if(this.emailUser)
      {
        
      //this.paginadoReportes.botonBuscar=false;
      this.paginadoReportes.numeroPagina = 1;
      this.paginadoReportes.email=this.emailUser;
      this.paginadoReportes.fechaInicio="";
      this.paginadoReportes.fechaFin="";
      this.paginadoReportes.rolUserlogin=this.idRolSeleccionado;
      //console.log(this.emailUser);
       this.cargarIniciativas();
      }
    });
  }


  //Método para aplicar filtro
  buscarIniciativas()
  {
    this.loadingGeneral = true;
    this.paginadoReportes.numeroPagina=1;
    this.paginadoReportes.fechaFin=this.fechaFin;
    this.paginadoReportes.fechaInicio=this.fechaInicio;
    this.dataService.obtenerIniciativasReporte(this.paginadoReportes).subscribe(res => {
      if (res['alert']==1) 
      {
        this.loadingGeneral = false;
        this.notifier.notify('error', 'No se han podido cargar las iniciativas. Revisa tu conexión de red e inténtalo de nuevo más tarde.');
      }
      else 
      {
        this.loadingGeneral = false;
        this.totalRegistros=res['total_registros'];
        this.tablaIniciativas= res['data'];
    }});

  }


  
  cargarIniciativas() 
  {
    this.loadingGeneral = true;
    this.dataService.obtenerIniciativasReporte(this.paginadoReportes).subscribe(
      data => {
        if (data['errorMessage']) 
        {
          this.notifier.notify('error', 'No se han podido cargar las iniciativas. Revisa tu conexión de red e inténtalo de nuevo más tarde.')
        }
        else{
          this.tablaIniciativas = data['data'];
          this.totalRegistros=data['total_registros'];
          if(data['data'].length < 1)
          {
            this.loadingGeneral = false;
          }else{
            this.loadingGeneral = false;

          }

        }
      }
    );
  }

  cargarSiguientes() 
  {
    this.loadingGeneral = true;
    this.paginadoReportes.numeroPagina++;
    this.paginadoReportes.email=this.emailUser;
      this.dataService.obtenerIniciativasReporte(this.paginadoReportes).subscribe(res => {
        if (res['alert']==1) 
        {
          this.notifier.notify('error', 'No se han podido cargar las iniciativas. Revisa tu conexión de red e inténtalo de nuevo más tarde.');
        } else {
         
            this.tablaIniciativas = res['data'];
        }
        this.loadingGeneral = false;
      });
  }

  cargarAnteriores() 
  {
    this.loadingGeneral = true;
    this.paginadoReportes.numeroPagina--;
    this.paginadoReportes.email=this.emailUser;
      this.dataService.obtenerIniciativasReporte(this.paginadoReportes).subscribe(res => {
        if (res['alert']==1) 
        {
          this.notifier.notify('error', 'No se han podido cargar las iniciativas. Revisa tu conexión de red e inténtalo de nuevo más tarde.');
        } else {
            this.tablaIniciativas = res['data'];
        }
        this.loadingGeneral = false;
      });
  }



  descargarReporte()
  {
    this.dataService.descargarArchivoReporte(this.paginadoReportes).subscribe(res => {

      let newBlob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(newBlob);
        return;
      }
      const data = window.URL.createObjectURL(newBlob);

     let link = document.createElement('a');
     link.href = data;
     link.download = "Reporte_iniciativas_registradas";
     link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));

    setTimeout(function () {
      // Para Firefox es necesario retrasar la revocacion del objeto ObjectURL
      window.URL.revokeObjectURL(data);
      link.remove();
    }, 100);
    });

}


  
/*convertBase64ToBlob()
{
  if(window.navigator && window.navigator.msSaveOrOpenBlob)
  { 
    // download PDF in IE
    let byteChar = atob(this.contentFile);
    let byteArray = new Array(byteChar.length);
    for(let i = 0; i < byteChar.length; i++){
      byteArray[i] = byteChar.charCodeAt(i);
    }
    let uIntArray = new Uint8Array(byteArray);
    let blob = new Blob([uIntArray], {type : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
    window.navigator.msSaveOrOpenBlob(blob, `${this.nombreArchivoSolicitud}.xlsx`);
  } else {
    // Download PDF in Chrome etc.
    const source = `data:application/xlsx;base64,${this.contentFile}`;
    const link = document.createElement("a");
    link.href = source;
    link.download = `${this.nombreArchivoSolicitud}`
    link.click();
  }
  
}*/





  //Limpiar filtro
  quitarFiltro(){
    this.paginadoReportes= new Paginado;
    this.fechaFin="";
    this.fechaInicio="";
    this.paginadoReportes.numeroPagina = 1;
    this.paginadoReportes.email=this.emailUser;
    this.paginadoReportes.fechaInicio="";
    this.paginadoReportes.fechaFin="";
    this.paginadoReportes.botonBuscar=false;
    this.paginadoReportes.rolUserlogin=this.idRolSeleccionado;
    this.cargarIniciativas();
  }



}
